import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconCommentEditFilledSizeL from './IconCommentEditFilled_size_l';
import IconCommentEditFilledSizeM from './IconCommentEditFilled_size_m';
import IconCommentEditFilledSizeS from './IconCommentEditFilled_size_s';
import IconCommentEditFilledSizeXs from './IconCommentEditFilled_size_xs';

const props: CreateIconArguments = {
  l: IconCommentEditFilledSizeL,
  m: IconCommentEditFilledSizeM,
  s: IconCommentEditFilledSizeS,
  xs: IconCommentEditFilledSizeXs,
  name: 'IconCommentEditFilled',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'mono',
};

export default props;
